//Parroquias Carabobo
const munBejuma = ['Bejuma', 'Canoabo', 'Simón Bolívar'];
const munCarlosArvelo = ['Güigüe', 'Belén', 'Tacarigua Central'];

const munDiegoIbarra = ['Aguas Calientes', 'Mariara'];

const munGuacara = ['Ciudad Alianza', 'Guacara', 'Yagua  '];
const munJuanJoseMora = ['Morón', 'Urama'];
const munLibertadorCarabobo = ['Tocuyito', 'Independencia'];

const munLosGuayos = ['Los Guayos'];

const munMiranda = ['Miranda'];
const munMontalban = ['Montalbán'];
const munNaguanagua = ['Naguanagua'];
const munPuertoCabello = [
  'Bartolomé Salom',
  'Democracia',
  'Fraternidad',
  'Goaigoaza',
  'Juan José Flores',
  'Unión',
  'Borburata',
  'Patanemo',
];
const munSanDiego = ['San Diego'];
const munSanJoaquin = ['San Joaquín'];
const munValencia = [
  'Candelaria',
  'Catedral',
  'El Socorro',
  'Miguel Peña',
  'Rafael Urdaneta',
  'San Blas',
  'San José',
  'Santa Rosa',
  'Negro Primero',
];

export const esCarabobo = [
  {
    municipio: 'Bejuma',
    parroquias: munBejuma,
  },
  {
    municipio: 'Carlos Arvelo',
    parroquias: munCarlosArvelo,
  },
  {
    municipio: 'Carlos Arvelo',
    parroquias: munCarlosArvelo,
  },
  {
    municipio: 'Diego Ibarra',
    parroquias: munDiegoIbarra,
  },
  {
    municipio: 'Guacara',
    parroquias: munGuacara,
  },
  {
    municipio: 'Juan José Mora',
    parroquias: munJuanJoseMora,
  },
  {
    municipio: 'Libertador',
    parroquias: munLibertadorCarabobo,
  },
  {
    municipio: 'Los Guayos',
    parroquias: munLosGuayos,
  },
  {
    municipio: 'Miranda',
    parroquias: munMiranda,
  },
  {
    municipio: 'Montalbán',
    parroquias: munMontalban,
  },
  {
    municipio: 'Naguanagua',
    parroquias: munNaguanagua,
  },
  {
    municipio: 'Puerto Cabello',
    parroquias: munPuertoCabello,
  },
  {
    municipio: 'San Diego',
    parroquias: munSanDiego,
  },
  {
    municipio: 'San Joaquín',
    parroquias: munSanJoaquin,
  },
  {
    municipio: 'Valencia',
    parroquias: munValencia,
  },
];
